import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { SparkObjectDataset } from 'app/model/dataset/spark.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SparkObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class SparkObjectDatasetAdapter extends TabularTypeDatasetAdapter<SparkObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: SparkObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(SparkObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: SparkObjectDataset): Promise<SparkObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, SparkObjectDataset.MODEL);
    }
}
